import {
  getAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGet,
  updateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPut,
} from './api/sdk.gen';

export const getHhrgCosts =
  getAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsGet;
export const updateHhrgCosts =
  updateAgencyClinicHhrgCostsAgencyClinicsAgencyClinicIdHhrgCostsPut;
